export const WWW_ROUTES = {
  PRODUCT_PAGE_STORAGE: '/book/storage',
  PRODUCT_PAGE_MOVING: '/book/moving',
  STORAGE_CART: '/book/storage/cart',
  STORAGE_SET_PASSWORD: '/book/storage/set-password',
  MOVING_CART: '/book/moving/cart',
  CHECKOUT_STEP_ADDRESS: '/checkout/steps/address',
  CHECKOUT_STEP_PLAN_SIZE: '/checkout/steps/plan_size',
  CHECKOUT_STEP_COMMITMENT: '/checkout/steps/commitment',
  CHECKOUT_STEP_QUOTE: '/checkout/steps/quote',
  CHECKOUT_STEP_ADDONS: '/checkout/steps/add_ons',
  CHECKOUT_STEP_DISPOSAL: '/checkout/steps/disposal',
  CHECKOUT_STEP_APPOINTMENT: '/checkout/steps/appointment',
  CHECKOUT_STEP_PAYMENT: '/checkout/steps/payment',
  CHECKOUT_STEP_PACKING: '/checkout/steps/packing',
  CHECKOUT_STEP_PROTECTION: '/checkout/steps/protection',
} as const;
